// extracted by mini-css-extract-plugin
export default {"skeletonRowOuter":"ARvdg","skeletonRow":"mmvD0","skeletonFixedCell":"WwKLy","skeletonCell":"bKUNo","skeletonInput":"R55xm"};